import {Observable} from 'rxjs';
import { Notification } from '@shared/interfaces';

export abstract class NotificationReceiverService {
    sendNotification$: Observable<Notification>;
}
